import { render, staticRenderFns } from "./ExtendedDoughnut.vue?vue&type=template&id=2cdfc8bb&"
import script from "./ExtendedDoughnut.vue?vue&type=script&lang=js&"
export * from "./ExtendedDoughnut.vue?vue&type=script&lang=js&"
import style0 from "./ExtendedDoughnut.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports